import { EnumTipoSujeto } from '../../../api'
import { apiGetSubjects } from '../../../api/Argentia/endpoints/clients/clients.api'
import {
  apiDeleteCommercial,
  apiFetchCommercialsBySubject,
  apiGetCommercialById,
  apiPostCommercial,
  apiUpdateCommercial
} from '../../../api/Argentia/endpoints/commercials/commercials.api'
import { apiFetchContractProductsBySubjectID } from '../../../api/Argentia/endpoints/contracts/contracts.api'
import {
  CommercialModel,
  NewCommercialModel
} from '../../../api/Argentia/model/commercials/commercial'
import { ContractProductAPIModel } from '../../../api/Pioneer/model/Contracts'
import {
  createSuccessServiceResponse,
  createErrorServiceResponse
} from '../../../helpers/serviceResponseHelper'
import i18n from '../../../i18n'
import { ServiceResponse } from '../../../model/serviceResponse'
import { notifyError } from '../../../redux'
import { SubjectFilterModel, SubjectTableModel } from '../../clients/clients.model'

export const fetchCommercialByID = async (
  commercialID: number
): Promise<ServiceResponse<CommercialModel | null | undefined>> => {
  return await apiGetCommercialById(commercialID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchCommercialsBySubjectID = async (
  subjectID: number
): Promise<ServiceResponse<any>> => {
  return await apiFetchCommercialsBySubject(subjectID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchContractProductsBySubjectID = async (
  subjectID: number
): Promise<ServiceResponse<ContractProductAPIModel[] | undefined>> => {
  return await apiFetchContractProductsBySubjectID(subjectID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const fetchCommercialSubjects = async (): Promise<
  ServiceResponse<SubjectTableModel[] | undefined>
> => {
  return await apiGetSubjects({
    subjectTypeList: [EnumTipoSujeto.Comercial],
    companyID: 1
  } as SubjectFilterModel)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const createCommercial = async (
  request: NewCommercialModel
): Promise<ServiceResponse<any>> => {
  return await apiPostCommercial(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      notifyError(i18n.t('commercials:forms.add.actions.save.errors.api'))
      return createErrorServiceResponse(error)
    })
}

export const updateCommercial = async (request: CommercialModel): Promise<ServiceResponse<any>> => {
  return await apiUpdateCommercial(request)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      notifyError(i18n.t('commercials:forms.add.actions.edit.errors.api'))
      return createErrorServiceResponse(error)
    })
}

export const deleteCommercial = async (commercialID: number): Promise<ServiceResponse<any>> => {
  return await apiDeleteCommercial(commercialID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      notifyError(
        i18n.t('clientFile:components.commercialsCard.dataTable.notifications.error.delete')
      )
      return createErrorServiceResponse(error)
    })
}
